import { useEffect } from 'react';

import { isApplicationLiveSyncEnabled } from '@/lib/applicationLiveSyncFlags';
import { useApplicationListSync } from '@/hooks/useApplicationListSync';
import {
  refreshBulkWatchEntries,
  startApplicationLiveSync,
  stopApplicationLiveSync,
} from '@/services/applications/applicationLiveSyncController';
import { useBulkProcessBannerStore } from '@/stores/bulkProcessBannerStore';

/**
 * Company-scoped Firestore listeners for application list live sync.
 * Mount once in AppLayout — pages register watch refs separately.
 */
export function useApplicationLiveSync(companyId: string | undefined): void {
  const listSync = useApplicationListSync();
  const bulkPhase = useBulkProcessBannerStore((s) => s.phase);

  useEffect(() => {
    if (!isApplicationLiveSyncEnabled() || !companyId) {
      stopApplicationLiveSync();
      return;
    }

    startApplicationLiveSync(companyId, listSync);
    return () => stopApplicationLiveSync();
  }, [companyId, listSync]);

  useEffect(() => {
    if (!isApplicationLiveSyncEnabled() || !companyId) return;
    refreshBulkWatchEntries(companyId);
  }, [companyId, bulkPhase]);
}
